'use client'

/* eslint-disable no-console */

import { useMemo } from 'react'
import { useSearchParams } from 'next/navigation'
import { Box } from '@mui/material'
import { InlineWidget, useCalendlyEventListener } from 'react-calendly'
import { useOddoIntegrationWithCalendly } from '@utils/calendly'
import { calendarUrl } from '@utils/environment'
import styles, { IFrameWrapper } from './styles.component'

export function CostimizerDemo() {
  const searchParams = useSearchParams()

  const customAnswers = useMemo(
    () => ({
      a2: searchParams.get('product') || '0',
      a3: searchParams.get('plan') || '0',
      a4: searchParams.get('type') || '0',
    }),
    [searchParams]
  )

  const { handleEventSchedule } = useOddoIntegrationWithCalendly()

  useCalendlyEventListener({
    onProfilePageViewed: () => {
      console.log('Calendly profile page viewed')
    },
    onDateAndTimeSelected: () => {
      console.log('Date and time selected')
    },
    onEventTypeViewed: () => {
      console.log('Event type viewed')
    },
    onEventScheduled: async (e) => {
      await handleEventSchedule(e)
    },
  })

  return (
    <Box sx={styles.wrapper}>
      <IFrameWrapper>
        <InlineWidget
          url={calendarUrl}
          prefill={{
            customAnswers,
          }}
          pageSettings={{
            textColor: '#2A2E3C',
            primaryColor: '#4540D5',
            hideEventTypeDetails: false,
            hideLandingPageDetails: false,
            hideGdprBanner: true,
          }}
          styles={{
            // height: ``,
            border: 'none',
            borderRadius: '12px',
          }}
        />
      </IFrameWrapper>
    </Box>
  )
}
